import Helpers from './helpers';
import Ping from './ping';

export default class ReviewPoke {
	constructor({ elements }) {
		elements.forEach((el) => {
			el.addEventListener('click', (e) => {
				e.preventDefault();
				ReviewPoke.sendReviewPoke(el);
			});
		});
	}

	static async sendReviewPoke(el) {
		const projectKeyValue = el.dataset?.projectKey;
		if (projectKeyValue != null) {
			await fetch(
				`/umbraco/api/professionalApi/SendReviewPokeToOrganization?projectKey=${projectKeyValue}`,
				{
					method: 'POST',
					headers: { 'Content-Type': 'application/json', Culture: document.documentElement.lang },
				}
			)
				.then((response) => {
					if (!response.ok) {
						throw new Error();
					} else {
						Ping.createHappyPing(response?.ping?.pingHeading, response?.ping?.pingBody);

						Helpers.removeVisibility(el);
					}
				})
				.catch((response) => {
					Ping.createSadPing(response?.ping?.pingHeading, response?.ping?.pingBody);
				});
		}
	}
}
